<template>
  <div class="bg-card overflow-hidden rounded-xl px-5 py-4 card-layout" :class="{ 'card-clickable': !!$attrs.onClick }">
    <div v-if="$slots.header" class="text-lg text-muted-foreground mb-5">
      <slot name="header"></slot>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.card-layout {
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

:is(.dark *).card-layout {
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.card-clickable {
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.card-clickable:hover {
  border-color: rgba(6, 200, 255, 0.35);
  box-shadow: 0 2px 12px rgba(6, 200, 255, 0.1);
}

:is(.dark *).card-clickable:hover {
  border-color: rgba(6, 200, 255, 0.45);
  box-shadow: 0 2px 14px rgba(6, 200, 255, 0.15);
}
</style>
